export enum TimelineView {
    None,
    InProgress,
    Solution,
}
